import { Edit } from '@otp/icons';
import { MostScheduledJobsDocument } from 'src/graphql/generated/graphql';
import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import { PartialMostScheduledJobListType } from 'src/components/most/list/scheduled-jobs/types';
import { ScheduledJobForm } from 'src/components/most/list/scheduled-jobs/form/scheduled-job';

type EditActionProps = {
  mostScheduledJob: PartialMostScheduledJobListType;
};

const QUERIES_TO_REFETCH = [MostScheduledJobsDocument];

export const EditAction = ({ mostScheduledJob }: EditActionProps) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'most.list.scheduled-jobs',
  });
  const [showForm, setShowForm] = useState(false);

  return (
    <>
      <Edit onClick={() => setShowForm(true)} />
      {showForm && (
        <ScheduledJobForm
          title={t('edit-scheduled-job')}
          refetchQueries={QUERIES_TO_REFETCH}
          onClose={() => setShowForm(false)}
          onFinish={() => setShowForm(false)}
          id={mostScheduledJob.id}
          entity={mostScheduledJob}
        />
      )}
    </>
  );
};
